import React from "react";
import termsBg from "./assets/uutoken.jpg"; // update path/name as per your project

const Terms = () => {
  return (
    <>
      {/* TOP IMAGE HEADER */}
      <div
        className="terms-header-bg text-center d-flex flex-column justify-content-center pt-5 pb-4"
        style={{
          backgroundImage: `url(${termsBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h1 className="fw-bold mb-2 text-white">Terms &amp; Conditions</h1>
        <p className="text-white-50 mb-0 small">
          Last Updated: November 22, 2025
        </p>
      </div>

      {/* WHITE CARD BODY */}
      <div className="container pb-5" style={{ maxWidth: "900px" }}>
        <div className="terms-card mx-auto shadow rounded-4 p-4 p-md-5 bg-white">
          <p className="text-secondary mb-4">
            Please read these Terms and Conditions carefully before registering
            and using the <strong>Tokenly</strong> mobile application provided
            by <strong>Biswaas Enterprises</strong>. By downloading,
            registering, or using the Tokenly app, you agree to be bound by the
            following terms:
          </p>

          {/* Patient Guidelines */}
          <div className="section-title">
            <i className="fa-solid fa-user-injured"></i> Patient Guidelines
          </div>
          <ul className="term-list">
            <li className="term-item">
              <span className="term-text-en">
                Tokenly is an app to procure token online, it is not an
                appointment.
              </span>
              <span className="term-text-hi">
                टोकनली ऑनलाइन टोकन प्राप्त करने के लिए एक ऐप है, यह कोई
                अपॉइंटमेंट नहीं है।
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                This is to facilitate patients to avoid waiting in long queues.
              </span>
              <span className="term-text-hi">
                यह मरीजों को लंबी कतारों में इंतजार करने से बचाने के लिए है।
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                To generate token online first download the app “TOKENLY” from
                play store.
              </span>
              <span className="term-text-hi">
                ऑनलाइन टोकन जनरेट करने के लिए सबसे पहले प्ले स्टोर से "टोकनली"
                ऐप डाउनलोड करें।
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                Register yourself as patient.
              </span>
              <span className="term-text-hi">
                खुद को रोगी के रूप में पंजीकृत करें।
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                You will get 2 free tokens at the time of registration.
              </span>
              <span className="term-text-hi">
                पंजीकरण के समय आपको 2 निःशुल्क टोकन प्राप्त होंगे।
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                Each token will cost Rs. 5/-, if you skipped your turn, you may
                regenerate token again.
              </span>
              <span className="term-text-hi">
                प्रत्येक टोकन की कीमत रु 5/-, यदि आप अपनी बारी छोड़ देते हैं, तो
                आप टोकन को पुन: उत्पन्न कर सकते हैं।
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                To avail the services you need minimum Rs 5/- in your app
                wallet.
              </span>
              <span className="term-text-hi">
                सेवाओं का लाभ उठाने के लिए आपको अपने ऐप वॉलेट में न्यूनतम 5/-
                रुपये की आवश्यकता है।
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                Any amount in app wallet will not be refundable in any case.
              </span>
              <span className="term-text-hi">
                ऐप वॉलेट में कोई भी राशि किसी भी स्थिति में वापस नहीं की जाएगी।
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                Token generated will be valid for given time slot only and for
                the same date only.
              </span>
              <span className="term-text-hi">
                जनरेट किया गया टोकन केवल दिए गए टाइम स्लॉट और उसी तारीख के लिए
                मान्य होगा।
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                Tokenly app restricted to doctors registered with us only.
              </span>
              <span className="term-text-hi">
                टोकनली ऐप केवल हमारे साथ पंजीकृत डॉक्टरों तक ही सीमित है।
              </span>
            </li>
            <li className="term-item text-danger border-danger">
              <span className="term-text-en">
                If you find any term not suitable, you should stop using this
                app and must uninstall.
              </span>
              <span className="term-text-hi">
                यदि आपको लगता है कि कोई शर्तें उपयुक्त नहीं हैं, तो आपको इस ऐप
                का उपयोग बंद कर देना चाहिए और अनइंस्टॉल करना चाहिए।
              </span>
            </li>
          </ul>

          {/* Doctor Registration & Use */}
          <div className="section-title">
            <i className="fa-solid fa-user-doctor"></i> Doctor Registration
            &amp; Use
          </div>
          <ul className="term-list">
            <li className="term-item">
              <span className="term-text-en">
                <strong>Registration:</strong> Doctors wishing to enable online
                and offline token booking services for patients at their clinics
                must download the Tokenly mobile application and register
                themselves accordingly.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                <strong>Free Onboarding:</strong> Biswaas Enterprises offers the
                Tokenly application to doctors without any subscription fee or
                onboarding charges. This is subject to change based on future
                updates or service modifications.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                <strong>Advertisement Rights:</strong> The company Biswaas
                Enterprises reserves the right to display and manage
                advertisements within the Tokenly mobile application and on any
                display devices installed at the doctor’s clinic. The revenue
                generated through such advertisements shall solely belong to
                Biswaas Enterprises.
              </span>
            </li>
          </ul>

          {/* Service Charges */}
          <div className="section-title">
            <i className="fa-solid fa-wallet"></i> Service Charges
          </div>
          <ul className="term-list">
            <li className="term-item">
              <span className="term-text-en">
                Biswaas Enterprises will charge a nominal fee of{" "}
                <strong>
                  ₹5/- (Rupees Five only, inclusive of GST)
                </strong>{" "}
                per online token issued through the application.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                This charge applies exclusively to online bookings.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                The amount will be directly credited to the official bank
                account of Biswaas Enterprises.
              </span>
            </li>
          </ul>

          {/* General Provisions */}
          <div className="section-title">
            <i className="fa-solid fa-scale-balanced"></i> General Provisions
          </div>
          <ul className="term-list">
            <li className="term-item">
              <span className="term-text-en">
                <strong>Modification of Terms:</strong> Biswaas Enterprises
                reserves the right to amend these Terms and Conditions at any
                time, as deemed necessary for operational, legal, or commercial
                purposes. Users are advised to review the Terms and Conditions
                periodically.
              </span>
            </li>
            <li className="term-item">
              <span className="term-text-en">
                <strong>Acceptance:</strong> By registering and using the
                Tokenly app, you acknowledge that you have read, understood, and
                agreed to abide by these Terms and Conditions.
              </span>
            </li>
          </ul>

          {/* Return to Home button */}
          <div className="text-center my-4 pt-3 border-top">
            <a
              href="/"
              className="btn btn-primary btn-lg d-inline-flex align-items-center shadow-sm"
            >
              <i className="fas fa-home me-2"></i>
              Return to Home Page
            </a>
          </div>

          {/* Contact box */}
          <div className="contact-box">
            <h5 className="fw-bold text-dark mb-3">Contact Us</h5>
            <p className="mb-1 text-muted">
              For any queries or support, please contact us at:
            </p>
            <div className="d-flex flex-wrap justify-content-center gap-3 mt-2">
              <a
                href="mailto:biswaasenterprises@gmail.com"
                className="text-decoration-none text-tokenly-primary fw-bold"
              >
                <i className="fa-solid fa-envelope me-1"></i>
                biswaasenterprises@gmail.com
              </a>
              <a
                href="tel:+918130172666"
                className="text-decoration-none text-tokenly-primary fw-bold"
              >
                <i className="fa-solid fa-phone me-1"></i>
                +91 81301 72666
              </a>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="disclaimer-text mt-3">
            You agree to explicitly inform visitors to your site that you have
            implemented the invisible reCAPTCHA on your site and that their use
            of the invisible reCAPTCHA is subject to the Google Privacy Policy
            and Terms of Use.
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
